import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Import FontAwesome Pro icons - Light variants
import {
  faTachometer as faTachometerLight,
  faCar as faCarLight,
  faThermometer as faThermometerLight,
  faCogs as faCogsLight,
  faTireFlat as faTireFlatLight,
  faTire as faTireLight,
  faWater as faWaterLight,
  faSteeringWheel as faSteeringWheelLight,
  faOilTemp as faOilTempLight,
  faOilCan as faOilCanLight,
  faWrench as faWrenchLight,
  faEngineWarning as faEngineWarningLight,
  faExclamationTriangle as faExclamationTriangleLight,
  faCarBattery as faCarBatteryLight,
  faTirePressureWarning as faTirePressureWarningLight,
  faGarageCar as faGarageCarLight,
  // CIN-6779: general (non-automotive) service icons
  // Animal
  faPaw as faPawLight,
  faDog as faDogLight,
  faCat as faCatLight,
  faCut as faCutLight,
  faBath as faBathLight,
  // Real Estate
  faHouse as faHouseLight,
  faKey as faKeyLight,
  faDoorOpen as faDoorOpenLight,
  faSign as faSignLight,
  // General
  faCalendar as faCalendarLight,
  faClock as faClockLight,
  faCheck as faCheckLight,
  faToolbox as faToolboxLight
} from '@fortawesome/pro-light-svg-icons';

// Import FontAwesome Pro icons - Regular variants
import {
  faTachometer as faTachometerRegular,
  faCar as faCarRegular,
  faThermometer as faThermometerRegular,
  faCogs as faCogsRegular,
  faTireFlat as faTireFlatRegular,
  faTire as faTireRegular,
  faWater as faWaterRegular,
  faSteeringWheel as faSteeringWheelRegular,
  faOilTemp as faOilTempRegular,
  faOilCan as faOilCanRegular,
  faWrench as faWrenchRegular,
  faEngineWarning as faEngineWarningRegular,
  faExclamationTriangle as faExclamationTriangleRegular,
  faCarBattery as faCarBatteryRegular,
  faTirePressureWarning as faTirePressureWarningRegular,
  faGarageCar as faGarageCarRegular,
  // CIN-6779: general (non-automotive) service icons
  // Animal
  faPaw as faPawRegular,
  faDog as faDogRegular,
  faCat as faCatRegular,
  faCut as faCutRegular,
  faBath as faBathRegular,
  // Real Estate
  faHouse as faHouseRegular,
  faKey as faKeyRegular,
  faDoorOpen as faDoorOpenRegular,
  faSign as faSignRegular,
  // General
  faCalendar as faCalendarRegular,
  faClock as faClockRegular,
  faCheck as faCheckRegular,
  faToolbox as faToolboxRegular
} from '@fortawesome/pro-regular-svg-icons';

// Import FontAwesome Pro icons - Duotone variants
import {
  faTachometer as faTachometerDuotone,
  faCar as faCarDuotone,
  faThermometer as faThermometerDuotone,
  faCogs as faCogsDuotone,
  faTireFlat as faTireFlatDuotone,
  faTire as faTireDuotone,
  faWater as faWaterDuotone,
  faSteeringWheel as faSteeringWheelDuotone,
  faOilTemp as faOilTempDuotone,
  faOilCan as faOilCanDuotone,
  faWrench as faWrenchDuotone,
  faEngineWarning as faEngineWarningDuotone,
  faExclamationTriangle as faExclamationTriangleDuotone,
  faCarBattery as faCarBatteryDuotone,
  faTirePressureWarning as faTirePressureWarningDuotone,
  faGarageCar as faGarageCarDuotone,
  // CIN-6779: general (non-automotive) service icons
  // Animal
  faPaw as faPawDuotone,
  faDog as faDogDuotone,
  faCat as faCatDuotone,
  faCut as faCutDuotone,
  faBath as faBathDuotone,
  // Real Estate
  faHouse as faHouseDuotone,
  faKey as faKeyDuotone,
  faDoorOpen as faDoorOpenDuotone,
  faSign as faSignDuotone,
  // General
  faCalendar as faCalendarDuotone,
  faClock as faClockDuotone,
  faCheck as faCheckDuotone,
  faToolbox as faToolboxDuotone
} from '@fortawesome/pro-duotone-svg-icons';

// Icon mapping based on your API response format and frontend icons.js
const iconMap = {
  // Automotive Service Icons - Light variants
  'fa-light-gauge': faTachometerLight,
  'fa-light-car': faCarLight,
  'fa-light-water-temperature': faThermometerLight,
  'fa-light-transmission': faCogsLight,
  'fa-light-tire-flat': faTireFlatLight,
  'fa-light-tire': faTireLight,
  'fa-light-tank-water': faWaterLight,
  'fa-light-steering-wheel': faSteeringWheelLight,
  'fa-light-oil-temperature': faOilTempLight,
  'fa-light-oil-can-drip': faOilCanLight,
  'fa-light-oil-can': faOilCanLight,
  'fa-light-car-wrench': faWrenchLight,
  'fa-light-engine-warning': faEngineWarningLight,
  'fa-light-brake-warning': faExclamationTriangleLight,
  'fa-light-car-battery': faCarBatteryLight,
  'fa-light-tire-pressure-warning': faTirePressureWarningLight,
  'fa-light-garage-car': faGarageCarLight,

  // Animal Service Icons - light variants (CIN-6779)
  'fa-light-paw': faPawLight,
  'fa-light-dog': faDogLight,
  'fa-light-cat': faCatLight,
  'fa-light-cut': faCutLight,
  'fa-light-bath': faBathLight,

  // Real Estate Service Icons - light variants (CIN-6779)
  'fa-light-house': faHouseLight,
  'fa-light-key': faKeyLight,
  'fa-light-door-open': faDoorOpenLight,
  'fa-light-sign': faSignLight,

  // General Service Icons - light variants (CIN-6779)
  'fa-light-calendar': faCalendarLight,
  'fa-light-clock': faClockLight,
  'fa-light-check': faCheckLight,
  'fa-light-toolbox': faToolboxLight,

  // Automotive Service Icons - Regular variants
  'fa-regular-gauge': faTachometerRegular,
  'fa-regular-car': faCarRegular,
  'fa-regular-water-temperature': faThermometerRegular,
  'fa-regular-transmission': faCogsRegular,
  'fa-regular-tire-flat': faTireFlatRegular,
  'fa-regular-tire': faTireRegular,
  'fa-regular-tank-water': faWaterRegular,
  'fa-regular-steering-wheel': faSteeringWheelRegular,
  'fa-regular-oil-temperature': faOilTempRegular,
  'fa-regular-oil-can-drip': faOilCanRegular,
  'fa-regular-oil-can': faOilCanRegular,
  'fa-regular-car-wrench': faWrenchRegular,
  'fa-regular-engine-warning': faEngineWarningRegular,
  'fa-regular-brake-warning': faExclamationTriangleRegular,
  'fa-regular-car-battery': faCarBatteryRegular,
  'fa-regular-tire-pressure-warning': faTirePressureWarningRegular,
  'fa-regular-garage-car': faGarageCarRegular,

  // Animal Service Icons - regular variants (CIN-6779)
  'fa-regular-paw': faPawRegular,
  'fa-regular-dog': faDogRegular,
  'fa-regular-cat': faCatRegular,
  'fa-regular-cut': faCutRegular,
  'fa-regular-bath': faBathRegular,

  // Real Estate Service Icons - regular variants (CIN-6779)
  'fa-regular-house': faHouseRegular,
  'fa-regular-key': faKeyRegular,
  'fa-regular-door-open': faDoorOpenRegular,
  'fa-regular-sign': faSignRegular,

  // General Service Icons - regular variants (CIN-6779)
  'fa-regular-calendar': faCalendarRegular,
  'fa-regular-clock': faClockRegular,
  'fa-regular-check': faCheckRegular,
  'fa-regular-toolbox': faToolboxRegular,

  // Automotive Service Icons - Duotone variants
  'fa-duotone-gauge': faTachometerDuotone,
  'fa-duotone-car': faCarDuotone,
  'fa-duotone-water-temperature': faThermometerDuotone,
  'fa-duotone-transmission': faCogsDuotone,
  'fa-duotone-tire-flat': faTireFlatDuotone,
  'fa-duotone-tire': faTireDuotone,
  'fa-duotone-tank-water': faWaterDuotone,
  'fa-duotone-steering-wheel': faSteeringWheelDuotone,
  'fa-duotone-oil-temperature': faOilTempDuotone,
  'fa-duotone-oil-can-drip': faOilCanDuotone,
  'fa-duotone-oil-can': faOilCanDuotone,
  'fa-duotone-car-wrench': faWrenchDuotone,
  'fa-duotone-engine-warning': faEngineWarningDuotone,
  'fa-duotone-brake-warning': faExclamationTriangleDuotone,
  'fa-duotone-car-battery': faCarBatteryDuotone,
  'fa-duotone-tire-pressure-warning': faTirePressureWarningDuotone,
  'fa-duotone-garage-car': faGarageCarDuotone,

  // Animal Service Icons - duotone variants (CIN-6779)
  'fa-duotone-paw': faPawDuotone,
  'fa-duotone-dog': faDogDuotone,
  'fa-duotone-cat': faCatDuotone,
  'fa-duotone-cut': faCutDuotone,
  'fa-duotone-bath': faBathDuotone,

  // Real Estate Service Icons - duotone variants (CIN-6779)
  'fa-duotone-house': faHouseDuotone,
  'fa-duotone-key': faKeyDuotone,
  'fa-duotone-door-open': faDoorOpenDuotone,
  'fa-duotone-sign': faSignDuotone,

  // General Service Icons - duotone variants (CIN-6779)
  'fa-duotone-calendar': faCalendarDuotone,
  'fa-duotone-clock': faClockDuotone,
  'fa-duotone-check': faCheckDuotone,
  'fa-duotone-toolbox': faToolboxDuotone
};

// Fallback icon
const defaultIcon = faTachometerRegular;

const DynamicIcon = ({ iconName, className = '', size, color, style = {}, ...props }) => {
  // If no iconName provided, don't render anything
  if (!iconName) {
    return null;
  }

  // Get the icon from the map, fallback to default if not found
  const icon = iconMap[iconName] || defaultIcon;

  // Check if this is a duotone icon
  const isDuotone = iconName && iconName.includes('duotone');

  // Combine className with any additional classes
  const combinedClassName = `dynamic-icon ${className}`.trim();

  // For duotone icons, set up CSS custom properties for the colors
  const combinedStyle = { ...style };

  if (color) {
    combinedStyle.color = color;

    if (isDuotone) {
      // Convert color to RGB for alpha manipulation
      const hexToRgb = (hex) => {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : null;
      };

      let primaryColor = color;
      let secondaryColor = color;

      // If color is a hex value, create alpha version
      if (color.startsWith('#')) {
        const rgb = hexToRgb(color);
        if (rgb) {
          primaryColor = color;
          secondaryColor = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.2)`;
        }
      } else if (color.startsWith('var(')) {
        // Handle CSS custom properties - we'll need to use CSS for alpha
        primaryColor = color;
        secondaryColor = color;
        // Set opacity on the secondary layer
        combinedStyle['--fa-secondary-opacity'] = '0.2';
      }

      // Set FontAwesome duotone custom properties
      combinedStyle['--fa-primary-color'] = primaryColor;
      combinedStyle['--fa-secondary-color'] = secondaryColor;
    }
  }

  return (
    <FontAwesomeIcon
      icon={icon}
      className={combinedClassName}
      size={size}
      style={combinedStyle}
      {...props}
    />
  );
};

export default DynamicIcon;